import { render, staticRenderFns } from "./warehouseItem.vue?vue&type=template&id=324a835e&scoped=true&"
import script from "./warehouseItem.vue?vue&type=script&lang=js&"
export * from "./warehouseItem.vue?vue&type=script&lang=js&"
import style0 from "./warehouseItem.vue?vue&type=style&index=0&id=324a835e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a835e",
  null
  
)

/* custom blocks */
import block0 from "./warehouseItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports